import { createFileRoute } from "@tanstack/react-router";
import { site } from "@/data/site";
import { Section } from "@/components/site/Section";
import { meta } from "@/lib/schema";

const title = "Privacybeleid | Vakkundig Verhuizingen & Transport";
const description =
  "Hoe Vakkundig Verhuizingen & Transport persoonsgegevens uit offerteaanvragen verwerkt, hoe lang wij ze bewaren en welke rechten je hebt.";

export const Route = createFileRoute("/privacybeleid")({
  head: () => meta({ title, description, path: "/privacybeleid" }),
  component: PrivacyPage,
});

const sections = [
  {
    heading: "Wie verwerkt je gegevens",
    text: `${site.name}, ${site.address.street}, ${site.address.postalCode} ${site.address.city}, KvK ${site.kvk}, is verantwoordelijk voor de verwerking van je persoonsgegevens. Je kunt ons bereiken via ${site.email} en ${site.phone}.`,
  },
  {
    heading: "Welke gegevens wij verwerken",
    text: "Wij verwerken de gegevens die je zelf invult of doorgeeft: naam, e-mailadres, telefoonnummer, het adres waar je vertrekt en waar je naartoe verhuist, de gewenste verhuisdatum, het type woning, het aantal vierkante meters, de gewenste extra diensten en je toelichting. Voor de facturatie verwerken wij daarnaast factuur- en betaalgegevens.",
  },
  {
    heading: "Waarvoor wij de gegevens gebruiken",
    text: "Wij gebruiken je gegevens om je offerteaanvraag te beoordelen, contact met je op te nemen, de verhuizing of het transport uit te voeren en te factureren, en om onze administratie- en garantieverplichtingen na te komen. Wij gebruiken je gegevens niet voor geautomatiseerde besluitvorming en verkopen ze nooit aan derden.",
  },
  {
    heading: "Grondslag",
    text: "De verwerking is nodig om de overeenkomst met jou uit te voeren of voorbereidende stappen daarvoor te zetten (je offerteaanvraag), en om te voldoen aan onze wettelijke administratieplicht.",
  },
  {
    heading: "Hoe lang wij bewaren",
    text: "Offerteaanvragen die niet tot een opdracht leiden bewaren wij maximaal 12 maanden. Gegevens die bij een uitgevoerde opdracht horen, bewaren wij 7 jaar, omdat de Belastingdienst dat van ons vraagt voor de financiële administratie.",
  },
  {
    heading: "Delen met anderen",
    text: "Wij delen gegevens alleen als dat nodig is: met onze boekhouder, met onze verzekeraar bij een schademelding, met een collega-verhuizer wanneer wij die inschakelen voor jouw opdracht, en met de leveranciers van onze website- en e-mailsystemen. Met deze partijen hebben wij afspraken over vertrouwelijkheid en beveiliging.",
  },
  {
    heading: "Beveiliging",
    text: "Onze website verstuurt gegevens via een beveiligde verbinding en aanvragen worden opgeslagen in een beveiligde database waar alleen onze medewerkers bij kunnen. Wij beveiligen onze accounts en beperken de toegang tot wie de gegevens nodig heeft.",
  },
  {
    heading: "Cookies",
    text: "Onze website gebruikt alleen functionele en technisch noodzakelijke cookies om de site goed te laten werken. Wij plaatsen geen advertentiecookies zonder jouw toestemming.",
  },
  {
    heading: "Je rechten",
    text: `Je mag je gegevens inzien, laten corrigeren, laten verwijderen of de verwerking laten beperken, en je kunt je gegevens laten overdragen. Stuur je verzoek naar ${site.email}; wij reageren binnen vier weken. Ben je niet tevreden met onze reactie, dan kun je een klacht indienen bij de Autoriteit Persoonsgegevens.`,
  },
];

function PrivacyPage() {
  return (
    <Section>
      <div className="mx-auto max-w-3xl">
        <h1 className="font-display text-3xl font-extrabold text-secondary sm:text-4xl">Privacybeleid</h1>
        <p className="mt-3 text-muted-foreground">
          Wij gaan zorgvuldig om met je gegevens. Hieronder leggen we uit welke gegevens wij
          verwerken, waarom, en welke rechten je hebt.
        </p>
        <div className="mt-10 space-y-8">
          {sections.map((section) => (
            <article key={section.heading}>
              <h2 className="font-display text-xl font-bold text-secondary">{section.heading}</h2>
              <p className="mt-2 leading-relaxed text-muted-foreground">{section.text}</p>
            </article>
          ))}
        </div>
      </div>
    </Section>
  );
}
